/**
 * Public Route Component
 * Redirects to dashboard if user is already authenticated
 * Used for pages like login that should not be accessible when logged in
 */

import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "@/feature/auth";

interface PublicRouteProps {
  readonly children: React.ReactNode;
}

export const PublicRoute = ({
  children,
}: PublicRouteProps): React.JSX.Element => {
  const location = useLocation();

  if (isAuthenticated()) {
    // If user came from a protected route, redirect back there
    const from = location.state?.from?.pathname || "/swarapoint/dashboard";
    return <Navigate to={from} replace />;
  }

  return <>{children}</>;
};

